import { store } from "@/store/index"
import { apim } from "@/constants/api"
import { addToCart, setCart, setCartCount } from "@/store/features/cartSlice"
import { getConfig } from "@/constants/config"
import { getQuantityCount } from "@/utils/cart"
import { showToast } from "@/store/features/genericSlice"

const { productBySkuEndPoint_compare, shareCartEndPoint } = require("@/constants/index")

export const getProductsBySku = async (skus,params) => {
  const {rows,profileName,collection}=params
  const res = await apim.get(
    `${productBySkuEndPoint_compare}?fl=*&q=*:*&rows=${rows}&profilename=${profileName}&collections=${collection}&fq=sku_s:("${skus}")`
  )
  if (res && res.data && res.data.response.docs) return res.data.response.docs
  return []
}


export const getSharedCart = async id => {
  const res = await apim.get(`${shareCartEndPoint}/${id}`)
  if (res && res.data) return res.data
  return
}

const showToastHandler = msg =>
  store.dispatch(
    showToast({
      message: msg,
      isVisible: true,
    })
  )

export const shareaddToCart = async (items, message, callback, clockID) => {
  const payload = []
  const CONFIG = await getConfig()
  const salesChannels = CONFIG?.salesChannelConfig?.map ?? {}
  items.forEach(product => {
    const fields = { salesChannel: salesChannels[product.brand] ?? "KOUS" }
    if (product.backorder) fields.isBackOrderable = true
    payload.push({
      action: product.isBundle ? "addbundle" : "addLineItem",
      sku: product.sku,
      quantity: product.quantity,
      custom: product.additionalInfo
        ? {
            type: { key: "lineItemShipping" },
            fields: {
              salesChannel: salesChannels[product.brand],
              roomInfo: product.additionalInfo.roomInfo,
              customQuantity: product.additionalInfo.customQuantity,
              overage: product.additionalInfo.overage,
            },
          }
        : {
            type: { key: "lineItemShipping" },
            fields: fields,
          },
    })
  })

  if (clockID) {
    payload.push({
      action: "setCustomType",
      type: { key: "order", typeId: "type" },
      fields: { CSRAssociateId: clockID, orderType: "ISC" },
    })
  }
  const body = {
    actions: payload,
  }
  await store
    .dispatch(addToCart(body))
    .unwrap()
    .then(res => {
      if (res) {
        store.dispatch(setCart(res))
        const quantityLineItems = res?.lineItems
        const payload = getQuantityCount(quantityLineItems)
        store.dispatch(setCartCount(payload))
        if (message) {
          showToastHandler(message)
        }
        if (callback) {
          callback({ res })
        }
      }
    })
}
